import React, {Component} from "react";
import LoadingIndicator from '../../utils/LoadingIndicator';
import { Button, Alert } from "reactstrap";
import moment from 'moment'


class Siteslist extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true
        }

    }
    componentDidMount() {
        this.setState({
            loading: false
        })

    }
    render() {
        if (this.props.sites.length === 0) {
            return(
                <Alert color="secondary" >
                    <small>You are currently not a member of any sites.</small>
                </Alert>
            )
        }
        else {
            return (
                <ul className="icons-list mb-5 list-inline">
                    {this.props.sites.map((site,index) => {
                            return (
                                <li key={index} className="mb-3 mt-3 listSiteItems">
                                    <i className={"fa fa-globe " + (site.online === 1? "text-success" : "text-danger")}></i>
                                    <div className="desc-n">
                                        <div className="title"><Button block color="link" className="text-left p-0 m-0" onClick={() => this.props.goToSite(`/site/overview/device_${site.deviceName}/${site.siteName.replace(/\s/g, "+")}`)}>{site.siteName}</Button></div>
                                        {site.online === 1? <div className="small text-muted text-lowercase pb-3">online</div> : <div className="small text-muted text-lowercase pb-3">offline</div>}
                                    </div>
                                    <div className="value mr-4">
                                        <div className="small text-muted">Alarms</div>
                                        {site.alarm === 1?<div className="small text-danger">alarm</div>:<div className="small text-muted">none</div>}
                                    </div>
                                    <div className="actions">
                                        <Button color="link" className="text-muted"><i className={`fa fa-signal text-${site.online === 1? (site.rssi < -85 ? "danger" : site.rssi < -75 ? "warning" : site.rssi < -65 ? "success" : "success" ) : "secondary"}`}></i></Button>
                                    </div>
                                </li>
                            );
                        }
                    )}
                </ul>
            )
        }

    }
}

export default Siteslist;



// WEBPACK FOOTER //
// ./src/components/Sitelist/Siteslist.js